export const SupportHook = {
    mounted() {
        console.info(`SupportHook mounted`);

        const supported = "credentials" in navigator && "PublicKeyCredential" in window;

        console.log(supported ? "passkeys supported 👍" : "passkeys not supported 👎");

        this.pushEventTo(this.el, "passkeys-supported", { supported });
    },
};
